<script lang="ts" setup>
import { i18n } from '@/i18n';
import EditIndividualBusiness from '../components/EditIndividualBusiness.vue';
import RegisterBusinessPageTab from '@/corePagesModule/components/RegisterBusinessPageTab.vue';
import EditIndividualBusinessPageTab from '../components/EditIndividualBusinessPageTab.vue';
import { useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import EditIndividualBaseBusiness from '../components/EditIndividualBaseBusiness.vue';

const t = i18n.t;
const route = useRoute();

const isNowViewIndividual = computed(() => {
  return route.path === '/business-edit-individual';
});

// Note: NewBaseTableContentに展開機能が実装されるまで関連取引は別テーブルで表示する
const isNowIndividualViewBaseBusiness = ref(false);
</script>
<template>
  <div class="edit-business">
    <h1 class="edit-business__title">{{ t('登録/入力') }}</h1>
    <div class="edit-business__header__tab">
      <RegisterBusinessPageTab />
    </div>
    <template v-if="isNowViewIndividual">
      <EditIndividualBusinessPageTab
        :is-base-business="isNowIndividualViewBaseBusiness"
        @click="
          (view) => {
            isNowIndividualViewBaseBusiness = view;
          }
        "
      />
      <EditIndividualBaseBusiness v-if="isNowIndividualViewBaseBusiness" />
      <EditIndividualBusiness v-else />
    </template>
    <template v-else>
      <!-- 一括編集 -->
    </template>
  </div>
</template>
<style lang="scss" scoped>
.edit-business {
  display: grid;
  padding: 16px;
  gap: 8px;
  &__title {
    font-family: Noto Sans JP;
    font-size: 22px;
    font-weight: 700;
    line-height: 31.86px;
    text-align: left;
    color: $textDefault;
  }
}
</style>
